/**
 * @generated SignedSource<<8cfdc4e180f77cde4fc3cf487dbc73d3>>
 * @relayHash 6ef31550f1a84f52975ad108912b1bc5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 55c51a3d63ff16775569e2936a90afe4aa4aa392c08de3ea8c4c25d05adf75fc

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceSmartFolderSyncTrigger = "AUTO" | "INITIAL_ACTIVATION" | "MANUAL" | "%future added value";
export type ConfluenceSyncSmartFolderInput = {
  folderId: string;
  force?: boolean | null;
  syncTrigger?: ConfluenceSmartFolderSyncTrigger | null;
};
export type useSyncSmartFolderMutation$variables = {
  cloudId: string;
  input: ConfluenceSyncSmartFolderInput;
};
export type useSyncSmartFolderMutation$data = {
  readonly confluence_syncSmartFolder: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly __typename: string;
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
  } | null;
};
export type useSyncSmartFolderMutation = {
  response: useSyncSmartFolderMutation$data;
  variables: useSyncSmartFolderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "message"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "kind": "ScalarField",
  "name": "success"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSyncSmartFolderMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceSyncSmartFolderPayload",
        "kind": "LinkedField",
        "name": "confluence_syncSmartFolder",
        "plural": false,
        "selections": [
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          },
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSyncSmartFolderMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceSyncSmartFolderPayload",
        "kind": "LinkedField",
        "name": "confluence_syncSmartFolder",
        "plural": false,
        "selections": [
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "6ef31550f1a84f52975ad108912b1bc5",
    "id": "55c51a3d63ff16775569e2936a90afe4aa4aa392c08de3ea8c4c25d05adf75fc",
    "metadata": {},
    "name": "useSyncSmartFolderMutation",
    "operationKind": "mutation",
    "text": "mutation useSyncSmartFolderMutation($cloudId:ID!,$input:ConfluenceSyncSmartFolderInput!){confluence_syncSmartFolder(cloudId:$cloudId,input:$input){errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}},success}}"
  }
};
})();

(node as any).hash = "dec225cf1fdd258fa67d70013e7073ba";

export default node;
